<section class="new-login-section">
    <div class="container " id="container">
        <div class="form-container sign-up-container">
            <div class="mobilebanner">
                <div class="mobile-back-btn" onclick="history.back()" *ngIf="steps1">
                    <i class="pi pi-chevron-circle-left "> </i> Back
                </div>

                <div class="mobile-back-btn" (click)="onClickSignUpOtpBack()" *ngIf="steps2">
                    <i class="pi pi-chevron-circle-left "> </i> Back
                </div>

                <img src="assets/img/login/login-banners.webp" alt="" class="mobile-sign-up">
            </div>
            <!-- <img src="assets/img/icon/tennis-ball.png" alt="" class="tennsi-ball"> -->
            <div class="steps-1 signup-steps " *ngIf="steps1">
                <form [formGroup]="signUpForm" *ngIf="this.signUpForm" (ngSubmit)="onSignupSubmit()">
                    <div class="heading-div mb-3">
                        <h1>Register</h1>
                    </div>
                    <!-- <span class="p-float-label w-100">
                    <input pInputText id="username" [(ngModel)]="value" />
                    <label htmlFor="username">Enter Mobile Number</label>
                </span> -->
                    <span class="w-100">
                        <label for="phoneNumber" class="w-100 text-left">Enter your mobile number for
                            verification</label>
                        <div class="mobile0numberField">
                            <p-inputNumber id="phoneNumber" mode="decimal" [useGrouping]="false"
                                formControlName="mobileNumber" [maxlength]="10" placeholder="00000 00000"
                                [ngClass]="{ 'is-invalid': ((signupFormSubmitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))}"
                                required>
                            </p-inputNumber>
                            <div class="number-code">
                                <span>+91</span>
                            </div>
                        </div>


                    </span>
                    <div *ngIf="((signupFormSubmitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.mobileNumber.errors.required">Mobile Number is required</div>
                        <div *ngIf="!f.mobileNumber.errors.required">
                            Please enter valid 10 digit mobile number.
                        </div>
                    </div>
                    <div *ngIf="showMessage" class=" invalid-feedback" role="">
                        {{message}}
                    </div>

                    <!-- <div class="referal-code-div" *ngIf="refferalcodeAvailable" >
                        Have Referral Code?
                    </div> -->
                    <!-- <div class="referal-code-div" *ngIf="refferalcodeAvailable" (click)="showDialog('bottom')" >
                        Have Referral Code?
                    </div> -->
                    <!-- <div class="referal-code-availabel"  *ngIf="refferalcodenotAvailable">
                        <span>Referral Code: 8HKkdmTsv</span> <span class="close-icon" (click)="removeReferalcode()" ><i class='bx bx-x'></i></span>
                    </div> -->
                    <div class="user-list">
                        <span class="p-float-label w-100">
                            <div class="text-left lable-div">Sign up as a </div>
                        </span>
                        <ul>
                            <li *ngFor="let userCategory of userCategories"
                                [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                    <div class="box">
                                        <div class="role-lis-details">
                                            <div class="user-name"> {{userCategory.name}} </div>
                                        </div>
                                        <p-radioButton formControlName="{{userCategory.slug}}"
                                            [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                            (onClick)="onUserCategorySelect($event,userCategory)">
                                        </p-radioButton>
                                    </div>
                                </label>

                            </li>

                        </ul>
                        <div *ngIf="showCategoryError">
                            <div>
                                <span> Please Select User Category</span>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-12 regitser-button continue-btn">
                        <button type="submit">Get OTP</button>
                    </div>
                    <div class="register-btn-div">
                        Already have an account? <a (click)="onSignInClick()">Login Now</a>
                    </div>
                </form>

            </div>
            <!-- <span class="p-float-label w-100">
                <input pInputText type="password" id="username" [(ngModel)]="value" />
                <label htmlFor="username">Password</label>
            </span> -->
            <!-- <a href="#">Forgot your password?</a>
			<button>Sign In</button> -->
            <form action="" *ngIf="steps2" class="mobie-verification-div register_div">
                <div class="col-md-12 steps-2" *ngIf="steps2">

                    <div class=" justify-content-center">
                        <div class="col-12 col-md-6 col-lg-4" style="min-width: 100%;">
                            <div class="card bg-white mb-5 mt-5 border-0" style="box-shadow: none;">
                                <div class="card-body p-0 text-center">
                                    <h4 class="verifyHeading">VERIFY </h4>
                                    <p class="otp-subheading">OTP sent to {{mobileNumber}}</p>
                                    <p class="resend text-muted mb-0"> <a (click)="onClickSignUpOtpBack()">Change
                                            number</a></p>

                                    <p class="enter_heading">Enter OTP</p>
                                    <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                        <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                                            [config]="config">
                                        </ng-otp-input>
                                        <div *ngIf="showOtpErrors && !showOtpErrorsMsg">
                                            <span style="color: red;">Please enter OTP.</span>
                                        </div>
                                        <div *ngIf="showOtpErrorsMsg">
                                            <span style="color: red;">{{otpErrorMessage}}</span>
                                        </div>


                                    </div>
                                    <!-- <p class="resend text-muted mb-0">
                                    You enter wrong number? <a (click)="backOtpForm()">Resend</a>
                                  </p> -->
                                </div>
                                <div id="login-submit">
                                    <button type="submit" class="btn btn-primary mb-3" (click)="onClickOtpSubmit()">
                                        Verify </button>

                                </div>
                                <div id="timer-btn-otp">
                                    <span *ngIf="!showResendButton">Resend OTP | {{displayTime}} {{transform(counter)}}
                                        mins </span>

                                    <!-- <span  *ngIf="!showResendButton">{{transform(counter)}}</span> -->
                                    <span *ngIf="showResendButton">
                                        <div>
                                            <a (click)="resendOtp()"
                                                style="text-decoration: underline;cursor: pointer; color: #1AEC36;">Resend</a>
                                        </div>
                                    </span>
                                </div>
                                <div class="or">
                                    <span>OR</span>
                                </div>
                                <button class="bl" (click)="onClickSignUpOtpBack()">Back to Login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="col-md-12 steps-3 profile-details-steps" *ngIf="steps3">
                <form [formGroup]="signUpForm2" *ngIf="this.signUpForm2" (ngSubmit)="onSignupSubmit2()">
                    <div class="heading-div desktop_header-setp3">
                        <h1>Profile Details</h1>
                        <!-- <span>Enter the details to log in
                        </span> -->
                    </div>
                    <div class="p-fluid grid profile-details-div">
                        <div class="top-header-mobile">
                            <h4>Personal Details</h4>
                        </div>
                        <!-- <div class="top-header-subHeading">
                            <span>Enter the details to log in</span>
                        </div> -->
                        <div class="row forms-personal-details">
                            <div class="field col-6 md:col-4">
                                <span class="forms-input-div">
                                    <label for="inputtext-left">First Name</label>
                                    <!-- <i class="pi pi-user"></i> -->
                                    <input pInputText type="text" id="fisrt-name" formControlName="firstName"
                                        placeholder="Enter First Name " class="form-control textCapital"
                                        autocomplete="off" required
                                        [ngClass]="{ 'is-invalid':((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))}">
                                </span>
                                <div *ngIf="((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))"
                                    class="invalid-feedback">
                                    <div *ngIf="signupF.firstName.errors.required">First Name is required</div>
                                    <div *ngIf="!signupF.firstName.errors.required">
                                        Only Alphabets allowed.
                                    </div>
                                </div>
                            </div>
                            <div class="field col-6 md:col-4">
                                <span class="forms-input-div">
                                    <label for="last-name">Last Name</label>
                                    <!-- <i class="pi pi-user"></i> -->
                                    <input pInputText type="text" formControlName="lastName"
                                        placeholder="Enter Last Name " class="form-control textCapital" id="last-name"
                                        autocomplete="off" required
                                        [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))}">
                                </span>
                                <div *ngIf="((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))"
                                    class="invalid-feedback">
                                    <div *ngIf="signupF.lastName.errors.required">Last name is required</div>
                                    <div *ngIf="!signupF.lastName.errors.required">
                                        Only Alphabets allowed.</div>
                                </div>
                            </div>
                            <div class="field col-6 md:col-4">
                                <span class="forms-input-div">
                                    <label for="email-address">Email Address</label>
                                    <!-- <i class="pi pi-envelope"></i> -->
                                    <input type="email" formControlName="email" class="form-control" id="email-address"
                                        placeholder="Enter Email Address " pInputText (input)="onEmailEnter()"
                                        autocomplete="off"
                                        [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched))) }">
                                </span>
                                <div *ngIf="((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched)))"
                                    class="invalid-feedback" style="margin-top: 0px!important;">
                                    <div *ngIf="signupF.email.errors.required">Email is required</div>
                                    <div *ngIf="!signupF.email.errors.required && signupF.email.errors.email">
                                        Enter valid email address.
                                    </div>
                                    <div *ngIf="signupF.email.errors.pattern">Enter valid email address</div>
                                </div>
                                <div *ngIf="showEmailErrorMessage" class="invalid-feedback">
                                    <div>{{emailMessageError}}</div>
                                </div>
                            </div>
                            <div class=" dobFeild field col-6 md:col-4">
                                <span class="forms-input-div d-setting">
                                    <label for="dob" class="floatinglable_main">DOB</label>
                                    <p-calendar formControlName="dob" [showIcon]="true" inputId="icon"
                                        [maxDate]="maxDate" [defaultDate]="defaultDate" placeholder="Birth Date"
                                        class="p-calendar" inputId="calendar" appendTo="body" [readonlyInput]="true"
                                        dateFormat="dd/mm/yy" (onSelect)="onDateSelect($event)" [yearNavigator]="true"
                                        [yearRange]="yearRange"
                                        [ngClass]="{ 'is-invalid': signup2Submitted && (signupF.dob.errors)}"></p-calendar>
                                </span>
                                <div *ngIf="((signup2Submitted && signupF.dob.errors) || (signupF.dob.errors && (signupF.dob.dirty || signupF.dob.touched)))"
                                    class="invalid-feedback">
                                    <div *ngIf="signupF.dob.errors.required">Date Of Birth is required
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="refrel code col-12 ">
                                <div class="qst">Do you have Referral Code ?</div>
                                <div class="flex align-items-center">
                                    <div class="questin-opt" (click)="showDiv = false">
                                        <p-radioButton formControlName="referralYes" inputId=" ingredient1"></p-radioButton>
                                        <label for="ingredient1" class="ml-2">No</label>
                                    </div>
                                    <div class="questin-opt" (click)="showDiv = true">
                                        <p-radioButton formControlName="referralNo" inputId="ingredient2"></p-radioButton>
                                        <label for="ingredient2" class="ml-2">Yes</label>
                                    </div>
                                </div>
                            </div> -->
                            <!-- *ngIf="showDiv" -->
                            <div class="field col-12 md:col-4 referral-div">
                                <span class="forms-input-div">
                                    <label for="referral-code">Referral Code</label>
                                    <input id="referral-code" type="text" formControlName="referral"
                                        class="form-control" style=" margin-top: 0px!important;"
                                        placeholder="Enter Referral Code" pInputText autocomplete="off">
                                </span>
                            </div>
                            <div *ngIf="showReferralErrorMessage" class="invalid-feedback">
                                <div>{{referralMessageError}}</div>
                            </div>

                            <div class="col-md-12 regitser-button">
                                <button type="submit">Save Details</button>
                            </div>
                        </div>
                    </div>
                </form>
                <form [formGroup]="signUpForm" (ngSubmit)="onSignupSubmit()"
                    style="width: calc(100% - 50px); margin: auto;">
                    <div class="user-list">
                        <span class="p-float-label w-100">
                            <div class="text-left lable-div">I Am a: </div>
                        </span>
                        <ul class="newCartegoryList">
                            <li *ngFor="let userCategory of userCategories"
                                [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                    <div class="box">
                                        <div class="role-lis-details">
                                            <div class="user-name"> {{userCategory.name}} </div>
                                        </div>
                                        <p-radioButton formControlName="{{userCategory.slug}}"
                                            [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                            (onClick)="onUserCategorySelect(userCategory, $event)">
                                        </p-radioButton>
                                    </div>
                                </label>
                            </li>
                        </ul>
                        <div *ngIf="showCategoryError">
                            <div>
                                <span> Please Select User Category</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="form-container sign-in-container " *ngIf="!showForgotPasswordForm">
            <div class="mobilebanner" [ngClass]="{'mobile-keyboard-open': keyboardOpen}">
                <!-- <div class="mobile-back-btn" (click)="onClickOtpback()" *ngIf="showMobileLoginOtpForm">
                    <img src="../../../assets/img/login/loginBack.svg" alt=""> Back
                </div> -->
                <!-- <div class="mobile-back-btn loginClose" [routerLink]="'/home'" *ngIf="!showMobileLoginOtpForm">
                    <img src="../../../assets/img/login/loginClose.svg" alt="">
                </div>
                <div class="mobile-back-btn loginClose" [routerLink]="'/home'" *ngIf="showMobileLoginOtpForm">
                    <img src="../../../assets/img/login/loginClose.svg" alt="">
                </div> -->
                <div class="banner_image" *ngIf="!showMobileLoginOtpForm">
                    <img src="../../../assets/img/login/TPL-App1.png" alt="">
                </div>
                <div class="banner_image banner2" *ngIf="showMobileLoginOtpForm">
                    <img src="../../../assets/img/login/TPL-App1.png" alt="">
                </div>
                <div class="sign-in-div" [ngClass]="{ 'OTPScreen': showMobileLoginOtpForm }">
                    <div class="heading-div">
                        <div class="loginLogo">
                            <img src="../../../assets/images/login/login-logo.png" alt="">
                        </div>
                        <h1>Login / Register</h1>
                        <div class="lines">
                            <hr>
                        </div>

                        <!-- <span>Please enter your credentials to access your account. </span> -->
                    </div>
                    <div class="app-login-page">

                        <div class="login-Title" *ngIf="!showMobileLoginOtpForm">
                            <div class="loginLogo">
                                <img src="../../../assets/images/login/login-logo.png" alt="">
                            </div>
                            <h1>Login / Register</h1>
                            <div class="lines">
                                <hr>
                            </div>
                            <!-- <span>Enter your mobile no. to get OTP </span> -->
                        </div>

                        <div class="col-md-12 p-p-0">
                            <div *ngIf="!showMobileLoginOtpForm" class="col-md-12 p-p-0">
                                <form class="login-form" [formGroup]="mobileLoginForm" *ngIf="this.mobileLoginForm"
                                    (ngSubmit)="onMobilePhoneSubmit('')">
                                    <div class="Phone form-lable ">
                                        <span class=" w-100">
                                            <!-- <label for="inputtext-left mobileVerificationTitle">Enter your mobile no.
                                                for verification 
                                            </label> -->
                                            <div class="mobile0numberField">
                                                <div class="countryCode">
                                                    <p-dropdown inputId="phoneCode" formControlName="phoneCode"
                                                        appendTo="body" [options]="countryCodeList"
                                                        optionLabel="phone_code" (onChange)="setCountryCode($event)"
                                                        [filter]="true"
                                                        [ngClass]="{ 'ng-dirty ng-invalid': submitted && this.mobileLoginForm.get('phoneCode').errors }">
                                                        <ng-template pTemplate="selectedItem" let-selectedOption>
                                                            <div
                                                                class="flex justify-content-center align-items-center gap-2">
                                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                                    [class]="'flag flag-' + selectedOption.code.toLowerCase()"
                                                                    style="width: 18px" />
                                                                <div>{{ selectedOption.phone_code }}</div>
                                                            </div>
                                                        </ng-template>
                                                        <ng-template let-country pTemplate="item">
                                                            <div class="flex align-items-center gap-2">
                                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                                    [class]="'flag flag-' + country.code.toLowerCase()"
                                                                    style="width: 18px" />&nbsp;&nbsp;
                                                                <span>{{ country?.phone_code }}</span>
                                                            </div>
                                                        </ng-template>
                                                    </p-dropdown>
                                                </div>
                                                <p-inputNumber [useGrouping]="false" id="inputtext-left"
                                                    formControlName="mobileNumber" [maxlength]="10"
                                                    placeholder="Mobile Number"
                                                    [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                                    required>
                                                </p-inputNumber>

                                            </div>
                                        </span>
                                    </div>
                                    <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                            Mobile number is required.
                                        </div>
                                        <div *ngIf="!mobNumberFormValidation.mobileNumber.errors.required">
                                            Please enter a valid 10 digit mobile number.
                                        </div>
                                    </div>
                                    <div class="invalidmobile invalid-feedback" *ngIf="showMobileFormErrors">
                                        {{mobileFormsErrors}}
                                    </div>
                                    <div class="invalidmobile invalid-feedback mobile-invalid-msg"
                                        *ngIf="showLoginMessage">
                                        <!-- {{loginErromessage}} -->
                                        User may not exist or in case of query please contact Administrator <a
                                            href="mailto:support@tplsport.com">support@tplsport.com</a>
                                    </div>
                                    <div id="login-submit" class="sendButtonMain">
                                        <button class="mt-3" type="submit">SEND OTP</button>
                                    </div>
                                    <div class="loginTrems">
                                        <p>By clicking 'Send OTP', you acknowledge that you have read and understood our
                                            <a routerLink="/termsandcondition">Terms and Conditions</a>
                                        </p>
                                    </div>
                                </form>
                            </div>
                            <div *ngIf="showMobileLoginOtpForm" class="col-md-12 otp-section">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="position-relative mb-3">
                                        <!-- <div class="card p-2 text-center"> -->
                                        <!-- <div class="col-md-12 otp-header">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h2>Login With OTP</h2>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="heading-div otpheading" style="display: block!important;">
                                            <div class="loginLogo mobileLogo-div">
                                                <img src="../../../assets/images/login/login-logo.png" alt="">
                                            </div>
                                            <h1>Enter OTP </h1>
                                            <div class="lines">
                                                <hr>
                                            </div>

                                            <!-- <span>Please enter your credentials to access your account. </span> -->
                                        </div>
                                        <!-- <p class="otp-subheading">OTP sent to {{mobileNumber}}</p> -->
                                        <!-- <h6>Please enter the one time password <br> to login your account
                                        </h6> -->
                                        <!-- <div> <span>A code has been sent to </span>
                                            <small>{{mobileNumber}}</small>
                                        </div> -->
                                        <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2 mb-2">

                                            <!-- <p class="enter_heading">Enter OTP</p> -->
                                            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                                [config]="config">
                                            </ng-otp-input>

                                            <div style="display: block;" class="show-otp-errors">
                                                <div *ngIf="showOtpErrors">
                                                    <span style="color: red;">Please enter valid OTP.</span>
                                                </div>
                                                <!-- <div *ngIf="showOtpLoginErrors">
                                                    <span style="color: red;">{{otpLoginErrors}}</span>
                                                </div> -->
                                                <div *ngIf="showOtpErrorsMsg">
                                                    <span style="color: red;">{{otpErrorMessage}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="otpBtn">
                                            <div id="login-submit">
                                                <button type="submit" (click)="onClickOtpLoginSubmit()" value="Submit">
                                                    VERIFY & PROCEED
                                                </button>

                                            </div>
                                        </div>

                                        <div class="otpFooter">
                                            <p class="resend text-muted mb-0 mt-0 text-center"> <a
                                                    style="cursor:pointer" (click)="onClickOtpback()">Change number</a>
                                            </p>
                                            <div id="timer-btn-otp">
                                                <span class="resendText" *ngIf="!showResendButton">Resend in
                                                    {{displayTime}}
                                                    {{transform(counter)}} </span>
                                                <span *ngIf="showResendButton">
                                                    <div class="resendBTN">
                                                        <a (click)="resendOtp()"
                                                            style="text-decoration: underline;cursor: pointer; color: #1AEC36;"
                                                            class="resendButton">Resend</a>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>


                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 steps-3 profile-details-steps" *ngIf="steps3">
                                <!-- <form [formGroup]="signUpForm2" *ngIf="this.signUpForm2" (ngSubmit)="onSignupSubmit2()">
                
                                    <div class="heading-div desktop_header-setp3" >
                                        <h1>Profile Details</h1>
                                        <span>Enter the details to log in
                                        </span>
                                    </div>
                
                                    <div class="p-fluid grid profile-details-div">
                                        <div class="top-header-mobile">
                                            <h4>Personal Details</h4>
                                        </div>
                                        <div class="top-header-subHeading">
                                            <span>Enter the details to log in</span>
                                        </div>
                                        <div class="row forms-personal-details">
                                            <div class="field col-6 md:col-4">
                                                <span class="forms-input-div">
                                                    <label for="inputtext-left">First Name</label>
                                                    <input pInputText type="text" id="fisrt-name" formControlName="firstName" placeholder="Enter First Name "
                                                        class="form-control textCapital " required
                                                        [ngClass]="{ 'is-invalid':((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))}">
                    
                                          
                                                </span>
                                                <div *ngIf="((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))"
                                                    class="invalid-feedback">
                                                    <div *ngIf="signupF.firstName.errors.required">First Name is required</div>
                                                    <div *ngIf="!signupF.firstName.errors.required">
                                                        Only Alphabets allowed.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="field col-6 md:col-4">
                                                <span class="forms-input-div">
                                                    <label for="last-name">Last Name</label>
                                                    <input pInputText type="text" formControlName="lastName" placeholder="Enter Last Name "
                                                        class="form-control textCapital" id="last-name" required
                                                        [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))}">
                
                                                </span>
                                                <div *ngIf="((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))"
                                                    class="invalid-feedback">
                                                    <div *ngIf="signupF.lastName.errors.required">Last name is required</div>
                                                    <div *ngIf="!signupF.lastName.errors.required">
                                                        Only Alphabets allowed.</div>
                                                </div>
                                            </div>
                                            <div class="field col-6 md:col-4">
                                                <span class="forms-input-div">
                                                    <label for="email-address">Email Address</label>
                                                    <input type="email" formControlName="email" class="form-control" id="email-address" placeholder="Enter Email Address "
                                                        pInputText
                                                        [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched))) }">
                                                
                                                </span>
                                                <div *ngIf="((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched)))"
                                                    class="invalid-feedback" style="margin-top: 0px!important;">
                                                    <div *ngIf="signupF.email.errors.required">Email is required</div>
                                                    <div *ngIf="!signupF.email.errors.required && signupF.email.errors.email">
                                                        Enter valid email address.
                                                    </div>
                                                    <div *ngIf="signupF.email.errors.pattern">Enter valid email address</div>
                                                </div>
                                                <div *ngIf="showMessage" class="invalid-feedback" role="">
                                                    {{message}}
                                                </div>
                    
                                            </div>
                                            <div class="field col-6 md:col-4">
                                                <span class="forms-input-div d-setting">
                                                    <label for="dob" class="floatinglable_main">DOB</label>
                                                    <p-calendar formControlName="dob" [showIcon]="true" inputId="icon" [maxDate]="maxDate"
                                                    placeholder="Birth Date" class="p-calendar" inputId="calendar" append="body"
                                                    dateFormat="dd/mm/yy" (onSelect)="onDateSelect($event)" [yearNavigator]="true" [yearRange]="yearRange"
                                                    [ngClass]="{ 'is-invalid': signup2Submitted && (signupF.dob.errors)}"></p-calendar>
                                                    
                                                </span>
                                                <div *ngIf="((signup2Submitted && signupF.dob.errors) || (signupF.dob.errors && (signupF.dob.dirty || signupF.dob.touched)))" class="invalid-feedback">
                                                    <div *ngIf="signupF.dob.errors.required">Date Of Birth is  required
                                                    </div>
                                                </div>
                                            </div> 
                                            <div class="field col-12 md:col-4 referral-div" >
                                                <span class="forms-input-div">
                                                    <label for="referral-code">Referral Code</label>
                                                    <input id="referral-code" type="text" formControlName="referral" class="form-control" style=" margin-top: 0px!important;" placeholder="Enter Referral Code"
                                                        pInputText>
                                                  <span class="optional-lable">(optional)</span>
                                                </span>
                                            </div>

                                            <div class="user-list">
                                                <span class="p-float-label w-100">
                                                    <div class="text-left lable-div">I Am A: </div>
                                                </span>
                                            <ul>
                                                <li *ngFor="let userCategory of userCategoryType"
                                                    [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                                    <label for="{{userCategory.slug}}" class="{{userCategory.slug}}">
                                                        <div class="box">
                                                            <div class="role-lis-details">
                                                                <div class="user-name"> {{userCategory.name}} </div>
                                                            </div>
                                                            <p-radioButton formControlName="{{userCategory.slug}}"
                                                                [value]="userCategory.status" inputId="{{userCategory.slug}}"
                                                                (onClick)="onUserCategorySelect($event,userCategory)">
                                                            </p-radioButton>
                                                        </div>
                                                    </label>
                    
                                                </li>
                    
                                            </ul>
                                            <div *ngIf="showCategoryError">
                                                <div>
                                                    <span> Please Select User Category</span>
                                                </div>
                                            </div>
                                            </div>
                                       
                                            <div class="col-md-12 regitser-button">
                                                <button type="submit">Save Details</button>
                                            </div>
                                        </div>
                                    </div>
                                </form> -->
                            </div>
                        </div>
                    </div>
                    <!-- <p-tabView>
                    
                        <p-tabPanel header="Login With Password">
                            <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                <div class="name form-lable">
                                    <span class=" w-100">
                                        <label htmlFor="email">Email</label>
                                        <input type="email" id="email" formControlName="email" pInputText placeholder="Email Address" [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.email.errors }"  required>
                                    </span>
                                </div>
                                <div *ngIf="loginFormSubmitted && loginf.email.errors" class="invalid-feedback">
                                    <div *ngIf="loginf.email.errors.required">Email is required</div>
                                    <div *ngIf="loginf.email.errors.email">Enter valid email address
                                    </div>
                                </div>
                                <div class="pwd form-lable">
                                    <span class="w-100">
                                        <label htmlFor="password_login">Password</label>
                                        <p-password [toggleMask]="true" id="password_login" formControlName="password"  placeholder="Password"
                                            [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.password.errors }"
                                            autocomplete="on" required>
                                        </p-password>
                                       
                                        
    
                                    </span>
                                </div>
                                <div *ngIf="loginFormSubmitted && loginf.password.errors" class="invalid-feedback">
                                    <div *ngIf="loginf.password.errors.required">Password is required
                                    </div>
                                    <div *ngIf="loginf.password.errors.minlength">Password must be at
                                        least 6
                                        characters
                                    </div>
                                </div>
                                <div class="col-md-12 input-form">
                                </div>
                                <div class="col-md-12 input-form mobile-p-none">
                                    <div *ngIf="isLoginFailed" class="alert alert-danger" role="alert">
                                        {{errorMessage}}
                                    </div>
                                </div>
                                <div class="forgot-p">
                                    <label for="rememberMe">
                                        <div class="forms">
                                          
                                            <p-checkbox formControlName="rememberMe" binary="true"
                                                inputId="rememberMe"></p-checkbox>
                                            <span>Remember me</span>
                                        </div>
                                    </label>
                                    <label for="forgot-password_login"> <a (click)="onClickForgotPassword()">
                                            Forgot
                                            Password</a></label>
                                </div>
                                <div id="login-submit" class="otp-submit">
                                    <button type="submit" value="Sign In">Login</button>
    
                                </div>
                            </form>
                            <div class="register-btn-div">
                                Don't have an account? <a (click)="onSignUpClick()">Register</a>
                            </div>
                        </p-tabPanel>
                    </p-tabView> -->
                </div>
                <div class="col-md-12 steps-3 profile-details-steps" *ngIf="steps3">
                    <form [formGroup]="signUpForm2" *ngIf="this.signUpForm2" (ngSubmit)="onSignupSubmit2()">
                        <div class="heading-div desktop_header-setp3">
                            <h1>Profile Details</h1>
                            <!-- <span>Enter the details to log in
                            </span> -->
                        </div>
                        <div class="p-fluid grid profile-details-div">
                            <div class="top-header-mobile">
                                <div class="topHeading-header">
                                    <a href="#">
                                        <div class="profileBackBtn">
                                            <img src="../../../assets/images/login/backBtn.svg" alt="">
                                        </div>
                                    </a>
                                    <h4>Profile Details</h4>
                                </div>
                                <div class="rightIcon">
                                    <img src="../../../assets/images/login/horizontalicon.svg" alt="">

                                </div>
                            </div>
                            <!-- <div class="top-header-subHeading">
                                <span>Enter the details to log in</span>
                            </div> -->
                            <div class="row forms-personal-details">
                                <div class="field col-6 md:col-4 mobile-two-column left">
                                    <span class="forms-input-div">
                                        <label for="inputtext-left">First Name</label>
                                        <!-- <i class="pi pi-user"></i> -->
                                        <input pInputText type="text" id="fisrt-name" formControlName="firstName"
                                            placeholder="Enter First Name " class="form-control textCapital " required
                                            [ngClass]="{ 'is-invalid':((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))}">
                                    </span>
                                    <div *ngIf="((signup2Submitted && signupF.firstName.errors) || (signupF.firstName.errors && (signupF.firstName.dirty || signupF.firstName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="signupF.firstName.errors.required">First Name is required</div>
                                        <div *ngIf="!signupF.firstName.errors.required">
                                            Only Alphabets allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-6 md:col-4 mobile-two-column right">
                                    <span class="forms-input-div">
                                        <label for="last-name">Last Name</label>
                                        <!-- <i class="pi pi-user"></i> -->
                                        <input pInputText type="text" formControlName="lastName"
                                            placeholder="Enter Last Name " class="form-control textCapital"
                                            id="last-name" required
                                            [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))}">
                                    </span>
                                    <div *ngIf="((signup2Submitted && signupF.lastName.errors) || (signupF.lastName.errors && (signupF.lastName.dirty || signupF.lastName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="signupF.lastName.errors.required">Last name is required</div>
                                        <div *ngIf="!signupF.lastName.errors.required">
                                            Only Alphabets allowed.</div>
                                    </div>
                                </div>
                                <div class="field col-6 col-sm-12 md:col-4 mobile-two-column left">
                                    <span class="forms-input-div">
                                        <label for="email-address">Email Address</label>
                                        <!-- <i class="pi pi-envelope"></i> -->
                                        <input type="email" formControlName="email" class="form-control"
                                            id="email-address" placeholder="Enter Email Address " pInputText
                                            (input)="onEmailEnter()"
                                            [ngClass]="{ 'is-invalid': ((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched))) }">

                                    </span>
                                    <div *ngIf="((signup2Submitted && signupF.email.errors) || (signupF.email.errors && (signupF.email.dirty || signupF.email.touched)))"
                                        class="invalid-feedback" style="margin-top: 0px!important;">
                                        <div *ngIf="signupF.email.errors.required">Email is required</div>
                                        <div
                                            *ngIf="!signupF.email.errors.required && (signupF.email.errors.email || signupF.email.errors.pattern)">
                                            Enter valid email address.
                                        </div>
                                    </div>
                                    <div *ngIf="showEmailErrorMessage" class="invalid-feedback">
                                        <div>{{emailMessageError}}</div>
                                    </div>
                                </div>
                                <div class="field col-6 col-sm-12 md:col-4 mobile-two-column right">
                                    <span class="forms-input-div d-setting">
                                        <label for="dob" class="floatinglable_main">DOB</label>
                                        <p-calendar formControlName="dob" [showIcon]="true" inputId="icon"
                                            [maxDate]="maxDate" [readonlyInput]="true" placeholder="Birth Date"
                                            class="p-calendar" inputId="calendar" appendTo="body"
                                            [defaultDate]="defaultDate" dateFormat="dd/mm/yy"
                                            (onSelect)="onDateSelect($event)" [yearNavigator]="true"
                                            [yearRange]="yearRange"
                                            [ngClass]="{ 'is-invalid': signup2Submitted && (signupF.dob.errors)}"></p-calendar>
                                    </span>
                                    <div *ngIf="((signup2Submitted && signupF.dob.errors) || (signupF.dob.errors && (signupF.dob.dirty || signupF.dob.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="signupF.dob.errors.required">Date Of Birth is required
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="refrel code col-12 ">
                                    <div class="qst">Do you have Referral Code ?</div>
                                    <div class="flex align-items-center">
                                        <div class="questin-opt" (click)="showDiv = false">
                                            <p-radioButton formControlName="referralYes" inputId=" ingredient1"></p-radioButton>
                                            <label for="ingredient1" class="ml-2">No</label>
                                        </div>
                                        <div class="questin-opt" (click)="showDiv = true">
                                            <p-radioButton formControlName="referralNo" inputId="ingredient2"></p-radioButton>
                                            <label for="ingredient2" class="ml-2">Yes</label>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- *ngIf="showDiv" -->
                                <div class="profile-refer">
                                    <div class="p-details-bottom">
                                        <div class="lines_main"></div>
                                        <div class="user-list user-type-list">
                                            <span class="mainTitle">
                                                <div class="labelTitle">User Type: </div>
                                            </span>
                                            <ul>
                                                <li *ngFor="let userCategory of userCategoryType"
                                                    [ngClass]="{ 'active': selectedCategory === userCategory.slug }">
                                                    <label [for]="'profile-user-type-' + userCategory.slug" class="{{userCategory.slug}}">
                                                        <div class="box">
                                                            <div class="role-lis-details">
                                                                <p-radioButton formControlName="{{userCategory.slug}}"
                                                                    [value]="userCategory.status"
                                                                    [inputId]="'profile-user-type-' + userCategory.slug"
                                                                    (onClick)="onUserCategorySelect($event,userCategory)">
                                                                </p-radioButton>
                                                                <div class="user-name"> {{userCategory.name}} </div>
                                                            </div>

                                                        </div>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div *ngIf="showCategoryError">
                                                <div>
                                                    <span> Please Select User Category</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="user-list sportType">
                                            <span class="mainTitle">
                                                <div class="labelTitle">Choose Your Sport: </div>
                                            </span>
                                            <div class="row mainRow">
                                                <label for="sport{{i}}" *ngFor="let sport of sportList; let i=index;"
                                                    class="card col-3     sportButtons d-flex justify-content-center align-items-center">
                                                    <p-checkbox [binary]="true" [value]="sport?.id" inputId="sport{{i}}"
                                                        (onChange)="onSelectSport($event, sport)"
                                                        [disabled]="sport?.disabled"></p-checkbox>
                                                    <h6 class="h6 text-secondary mt-2">{{ sport?.name }}</h6>
                                                </label>
                                            </div>
                                            <div *ngIf="showSportSelectionError">
                                                <div>
                                                    <span class="text-danger"> Please choose your sport</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="lines_main mb-3"></div>
                                        <div class="field col-12 md:col-4 referral-div">
                                            <span class="forms-input-div">
                                                <label for="referral-code">Referral Code</label>
                                                <input id="referral-code" type="text" formControlName="referral"
                                                    class="form-control" style=" margin-top: 0px!important;"
                                                    placeholder="Enter Referral Code" pInputText>

                                            </span>
                                        </div>
                                        <div *ngIf="showReferralErrorMessage" class="invalid-feedback">
                                            <div>{{referralMessageError}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 regitser-button">
                                    <button type="submit">Save Details</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-md-12 form-container sign-in-container forgot-password-container"
            *ngIf="showForgotPasswordForm">
            <div class="mobilebanner" [ngClass]="{'mobile-keyboard-open': keyboardOpen}">
                <img src="assets/img/login/login2.png" alt="">
            </div>
            <div class="sign-in-div forgot-p-div">
                <form [formGroup]="forgotPassForm">
                    <div class="row m-0 w-100">
                        <div class="col-lg-12">
                            <h4>
                                Forgot Password
                            </h4>
                            <div class="style-form-group forgot-password-div form-lable">
                                <div class="name form-lable">
                                    <span class=" w-100">
                                        <label htmlFor="email">Email</label>
                                        <input type="email" id="email" formControlName="email" pInputText
                                            placeholder="Enter Email Address"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                    </span>
                                    <div *ngIf="submitted && forgotPassValidation.email.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forgotPassValidation.email.errors.required">
                                            Email is required.
                                        </div>
                                        <div *ngIf="forgotPassValidation.email.errors.pattern">
                                            Please enter a valid email id.
                                        </div>
                                    </div>
                                    <div *ngIf="successMessage" style="color:green;">
                                        {{successMessage.message}}
                                    </div>
                                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="button pt-2 pt-lg-3 forgot-password-div ">
                        <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                        &nbsp;&nbsp;
                        <button class="forgot-pass-submit" (click)="onForgotPassSubmit()">Submit</button>
                    </div>
                </form>
            </div>
        </div>
        <div id="overlay_container" class="">
            <div class="overlay">
                <div class="overlay-panel overlay-left">
                    <div class="desktop-banners">
                        <img src="assets/img/login/login-banners.webp" alt="" style="width: 100% !important;
                        height: 100% !important;">
                    </div>
                    <div class="text-div">
                        <h1>Welcome Back To TPL!</h1>
                        <p>Please enter your credentials to access your account. </p>
                        <button class="ghost" id="signIn" (click)="onSignInClick()">Login</button>
                    </div>
                </div>
                <div class="overlay-panel overlay-right deskTop_version">
                    <div class="desktop-banners">
                        <img src="assets/img/login/login-banners.webp" alt="">
                    </div>
                    <!-- <div class="text-div deskTop_version_text">
                        <h1>Join TPL and Elevate Your Tennis Experience!
                        </h1>
                        <p>Register now to enjoy exclusive access to premium tennis content and community features.
                        </p>
                        <button class="ghost" id="signUp" (click)="onSignUpClick()">Register</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>
